import * as React from "react"
import styled from 'styled-components'

const DivStyled = styled.div`

&.line-box {
    width: 20rem;
    border: 2px solid #66279b;
    padding: 1.5rem 2rem;
    color: #66279b;
    margin: 0.2rem auto;
    position: relative;
    box-sizing: border-box;
    font-size: 16px;

    :after {
        content: '';
        width: 101%;
        height: 102%;
        position: absolute;
        top: -12px;
        left: -13px;
        border: 2px solid #66279b;
    }

    .-small {
        width: 15rem;
    }

    .percent {
        font-size: 3rem;
        text-align: center;
        font-weight: 700;
    }

    .item{
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        justify-content: space-between;
        margin: .5rem 0;
        color: #505050;
        font-weight: 600;

        .percent {
            font-size: 16px;
            font-weight: 300;
        }
    }

}
`

export default (node: any) => {
    return <DivStyled className="line-box">
        {node.children}
    </DivStyled>
}